import { NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { AnswerChoice, SinisterGlass } from '@sc/data-access-models';
import { FeatureFlippingManagerService } from '@sc/feature-flipping';
import { CarImgService } from '../../services/car-img-service';
import { CarImgSummaryComponent5Lat } from './car-img-summary-5-lat';
import { CarImgSummaryComponentBasic } from './car-img-summary-basic';

@Component({
  selector: 'sc-car-img-summary',
  styleUrls: ['./car-img-summary.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CarImgService],
  imports: [NgIf, CarImgSummaryComponentBasic, CarImgSummaryComponent5Lat],
  template: `
    <sc-car-img-summary-basic
      *ngIf="useBasicCarSummary()"
      [glasses]="formatGlassToArray()"
      [editMode]="editMode"
      (glassChangeEvent)="onGlassChange($event)"
    ></sc-car-img-summary-basic>
    <sc-car-img-summary-5-lat
      *ngIf="featureFlippingManager.isFeatureActivated('use-car-summary-5-lat')"
      [glasses]="formatGlassToArray()"
      [editMode]="editMode"
      (glassChangeEvent)="onGlassChange($event)"
    ></sc-car-img-summary-5-lat>
  `,
})
export class CarImgSummaryComponent {
  @Input() glass: SinisterGlass | SinisterGlass[];
  @Input() editMode = false;

  @Output() glassChangeEvent = new EventEmitter<AnswerChoice>();

  constructor(public featureFlippingManager: FeatureFlippingManagerService) {}

  useBasicCarSummary() {
    return !this.featureFlippingManager.isFeatureActivated(
      'use-car-summary-5-lat'
    );
  }

  formatGlassToArray() {
    if (Array.isArray(this.glass)) {
      return this.glass.filter((glass) => !!glass);
    }

    if (!this.glass?.glass) {
      return [];
    }

    return [this.glass];
  }

  onGlassChange(answers: AnswerChoice) {
    this.glassChangeEvent.emit(answers);
  }
}
